import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IChips, IChipsWithArea } from '@shared/components/v1/chips/chips.interface';
import { STRING_CONSTANTS } from '@config/constants/string.constants';

@Component({
  selector: 'app-chips-legacy',
  templateUrl: './chips-legacy.component.html',
  styleUrls: ['../v1/chips/chips.component.scss'],
})
export class ChipsListLegacyComponent implements OnInit {
  @Input() chipsList: any[] | IChips[] | IChipsWithArea[] = [];
  @Input() disabled: boolean = false;
  @Input() limitShow: number = 5;
  @Input() labelTextStyle: 'capitalize' | 'uppercase' = 'capitalize';
  @Output() dataOutput = new EventEmitter();
  @Output() removeSelectDataOutput = new EventEmitter();

  showMore = false;

  constructor() {}

  ngOnInit(): void {
    // console.log(' chips-legacy.component: chipslist ', this.chipsList);
  }

  handleRemoveChip(item: IChips) {
    this.chipsList.map((list) => {
      if (list.id === item.id) {
        list.selected = false;
      }
    });
    this.removeSelectDataOutput.emit(item);
    this.chipsList = this.chipsList.filter((list) => list.id !== item.id);
    this.dataOutput.emit(this.chipsList);
  }

  toggleShowMore() {
    this.showMore = !this.showMore;
  }

  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
}
